var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTg = function SvgTg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9621 4.18185L3.12084 10.7098C2.44312 11.0138 2.2139 11.6226 2.95704 11.953L7.27754 13.3331L17.724 6.84362C18.2944 6.43622 18.8783 6.54485 18.3758 6.99302L9.40375 15.1586L9.12191 18.6143C9.38295 19.1478 9.86093 19.1503 10.1658 18.8851L12.6481 16.5242L16.8993 19.7241C17.8867 20.3117 18.424 19.9325 18.6364 18.8556L21.4249 5.58366C21.7144 4.25803 21.2207 3.67395 19.9621 4.18185Z",
    fill: "#131616"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTg);
export default ForwardRef;